import { MasterDetailListEntry } from '@sdbn/common';

export enum StationGroupType {
  ROUTING = 'ROUTING', STRUCTURE = 'STRUCTURE', ROUTING_AND_STRUCTURE = 'ROUTING_AND_STRUCTURE'
}

export class StationGroup implements MasterDetailListEntry {

  id: number;
  name: string;
  description: string;
  stationSets: StationSet[] = [];
  deleted: boolean;
  externalKey: string;
  stationGroupType = StationGroupType.ROUTING;

  constructor(stationGroup?: any) {
    if (stationGroup != null) {
      this.id = stationGroup.id;
      this.name = stationGroup.name;
      this.description = stationGroup.description;
      this.deleted = stationGroup.deleted;
      this.externalKey = stationGroup.externalKey;
      this.stationGroupType = stationGroup.stationGroupType;
      if (stationGroup.stationSets != null) {
        for (let stationSet of stationGroup.stationSets) {
          this.stationSets.push(new StationSet(stationSet));
        }
      }

      // stations
    }
  }

  public get listTitle(): string {
    return this.name;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }
  listSubTitle: string;

  public get groupIdentifier(): String {
    return null;
  }

  public get childs(): Array<MasterDetailListEntry> {
    return this.stationSets.filter(c => !c.deleted);
  }

}

export enum StationSetType {
  ROUTING = 'ROUTING', STRUCTURE = 'STRUCTURE', ROUTING_AND_STRUCTURE = 'ROUTING_AND_STRUCTURE'
}


export class StationSet implements MasterDetailListEntry {
  id: number;
  stationType: StationType;
  name: string;
  description: string;
  internal: string;
  stations: Station[] = [];
  deletedStations: Station[] = [];
  deleted = false;
  externalKey: string;
  referenceDuration: number;
  backupStationSets: BackupStationSet[] = [];
  stationSetType = StationSetType.ROUTING;

  constructor(stationSet?: any) {
    if (stationSet != null) {
      this.id = stationSet.id;
      this.stationType = stationSet.stationType;
      this.name = stationSet.name;
      this.description = stationSet.description;
      this.internal = stationSet.internal;
      this.deleted = stationSet.deleted;
      this.externalKey = stationSet.externalKey;
      this.referenceDuration = stationSet.referenceDuration;
      this.stationSetType = stationSet.stationSetType;

      if (stationSet.stations != null) {
        for (let station of stationSet.stations) {
          this.stations.push(new Station(station));
        }
      }

      if (stationSet.backupStationSets != null) {
        for (let backupSet of stationSet.backupStationSets) {
          this.backupStationSets.push(new BackupStationSet(backupSet));
        }
      }
    }
  }

  public get listTitle(): string {
    return this.name;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }
  listSubTitle: string;

  public get groupIdentifier(): String {
    return null;
  }

  public get childs(): Array<MasterDetailListEntry> {
    return null;
  }
}

export enum StationType {
  WORKING_AREA = 'WORKING_AREA',
  WAITING_AREA = 'WAITING_AREA'
}

export class Station {

  id: number;
  name: string;
  description: string;
  stationType: StationType;
  index: number;

  constructor(station?: any) {
    if (station != null) {
      this.id = station.id;
      this.name = station.name;
      this.description = station.description;
      this.stationType = station.stationType;
      this.index = station.index;
    }
  }

}

export class BackupStationSet {
  name: string;
  stationSetId: number;

  constructor(stationSet?: any) {
    if (stationSet != null) {
      this.name = stationSet.name;
      this.stationSetId = stationSet.stationSetId;
    }
  }
}
